import { SectionType } from './analyze';

export enum Provider {
  OPENAI = 'openai',
  ANTHROPIC = 'anthropic',
  MISTRAL = 'mistral',
}

export enum SuggestionStatus {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  SHORTLISTED = 'shortlisted',
}

export enum ClaudeBatchStatus {
  IN_PROGRESS = 'in_progress',
  CANCELING = 'canceling',
  ENDED = 'ended',
}

export enum OpenAiBatchStatus {
  VALIDATING = 'validating',
  FAILED = 'failed',
  IN_PROGRESS = 'in_progress',
  FINALIZING = 'finalizing',
  COMPLETED = 'completed',
  EXPIRED = 'expired',
  CANCELLING = 'cancelling',
  CANCELLED = 'cancelled',
}

export enum OrphanType {
  MISSED_SECTIONS = 'missed_sections',
  MISSED_EMBEDDINGS = 'missed_embeddings',
}

export interface ClassifyResult {
  readonly class: string;
  readonly confidence: number;
  readonly notes: string;
  readonly language: string;
}

export interface ExtractionResult {
  readonly id: number;
  readonly summary: {
    readonly role: string;
    readonly summary: string;
  };
  readonly experience: {
    readonly company: string;
    readonly position: string;
    readonly responsibilities: string[];
    readonly dates: string;
  }[];
  readonly education: {
    readonly institution: string;
    readonly degree: string;
    readonly dates: string;
    readonly description: string;
  }[];
  readonly other: string;
}

export interface Section {
  readonly id: string;
  readonly fileId: number;
  readonly chunkId: number;
  readonly type: SectionType;
  readonly text: string;
}

export interface ProcessExistedBatch {
  readonly batchId: string;
  readonly provider: Provider;
}

export interface OpenAiBatchResult<T> {
  readonly data: T[];
  readonly messageId: string;
  readonly usedTokens: number;
}

export interface ProcessOrphanTextContent {
  readonly portalId: number;
  readonly type: OrphanType;
}

export interface VectorSearchWeights {
  /** Fraction of competence similarity; defaults to 0.2 when omitted. */
  readonly competenceWeight?: number;
  readonly filterTitleWeight: number;
  readonly filterDescriptionWeight: number;
  readonly sectionSummary: number;
  readonly sectionExperience: number;
  readonly sectionDoc: number;
  readonly sectionEducation: number;
  readonly sectionOther: number;
  readonly scoreTitleWeight: number;
  readonly scoreDescriptionWeight: number;
}

export interface Result {
  readonly birthDate: string;
  readonly city: string;
  readonly currency: string;
  readonly englishLevel: string;
  readonly firstName: string;
  readonly middleName: string;
  readonly lastName: string;
  readonly emails: string[];
  readonly phones: string[];
  readonly professionalLevel: string;
  readonly telegrams: string[];
  readonly socialLinks: string[];
  readonly mainSkill: string;
  readonly hardSkills: string[];
  readonly softSkills: string[];
  readonly salary: number;
  readonly speciality: string;
  readonly summary: string;
}
